import { render } from "./UserIntro.vue?vue&type=template&id=462d206e&scoped=true"
import script from "./UserIntro.vue?vue&type=script&lang=js"
export * from "./UserIntro.vue?vue&type=script&lang=js"

import "./UserIntro.vue?vue&type=style&index=0&id=462d206e&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462d206e"]])

export default __exports__